import React from "react";
import { Link } from "react-router-dom";

const GetStarted = () => {
  return (
    <>
      <section className="py-20">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px] bg-custom items-center px-4 py-20 rounded-[30px]">
            <div className="max-w-[450px] mt-3 mx-auto text-center md:text-left">
              <h2 className="font-bold text-white text-[32px]">
                Get Started With Landik
              </h2>
              <p className="text-white mt-4">
                It has survived not only five centuries, but also the leap into
                electronic typesetting.
              </p>
            </div>
            <div className="max-w-[450px] text-center w-full md:text-right mx-auto">
              <Link to="#" className="btn-white font-bold">
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GetStarted;
